// Display names for authors.
//
// User rows only carry a login username ("haris.velic", "maja"), and that is
// what the blog printed in its byline, RSS feed and Person structured data. A
// username is not a name: search engines and AI assistants weigh named authors,
// and "maja" tells a reader nothing. The schema has no name field and deploys
// don't run `prisma db push`, so the mapping lives here.

const AUTHOR_NAMES = {
  "haris.velic": "Haris Velic",
  "belma.kapetanovic": "Belma Kapetanovic",
  "vedran.kolaric": "Vedran Kolaric",
  maja: "Maja Senk",
};

/**
 * @param {string | null | undefined} username
 * @returns {string | null} the author's full name, or a readable fallback
 *   ("first.last" -> "First Last") for users not listed above
 */
export function authorName(username) {
  if (!username) return null;
  if (AUTHOR_NAMES[username]) return AUTHOR_NAMES[username];
  return username
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
